export const API_LOGIN_SUCCESS = "API_LOGIN_SUCCESS";
export const API_LOGIN_FAIL = "API_LOGIN_FAIL";
export const GET_LOGIN = "GET_LOGIN";
export const REMOVE_LOGIN_DATA = "REMOVE_LOGIN_DATA";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";